import { render } from "./NewPassword.vue?vue&type=template&id=71bb4d51&scoped=true&ts=true"
import script from "./NewPassword.vue?vue&type=script&lang=ts"
export * from "./NewPassword.vue?vue&type=script&lang=ts"

import "./NewPassword.vue?vue&type=style&index=0&id=71bb4d51&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bb4d51"]])

export default __exports__